// 用户信息专用选择器 hooks - 遵循最佳实践
import { useShallow } from 'zustand/react/shallow';

import { useUserInfoStore } from './slice';

// 获取完整用户信息状态的选择器
export const useUserInfoState = () =>
    useUserInfoStore(
        useShallow(state => ({
            userInfo: state.userInfo,
            isLogin: state.isLogin,
            preferences: state.preferences,
        }))
    );

// 获取用户信息动作的选择器
export const useUserInfoActions = () =>
    useUserInfoStore(
        useShallow(state => ({
            setUserInfo: state.setUserInfo,
            setIsLogin: state.setIsLogin,
            logout: state.logout,
            updateUserInfo: state.updateUserInfo,
            setPreferences: state.setPreferences,
        }))
    );

// 单独的状态选择器（用于只需要特定状态的场景）
export const useUserInfo = () => useUserInfoStore(state => state.userInfo);
export const useIsLogin = () => useUserInfoStore(state => state.isLogin);
export const useUserPreferences = () => useUserInfoStore(state => state.preferences);

// 组合选择器（用于常见的组合需求）
export const useUserProfile = () =>
    useUserInfoStore(
        useShallow(state => ({
            ...state.userInfo,
            isLoggedIn: state.isLogin,
        }))
    );

// 用户认证状态选择器
export const useAuthState = () =>
    useUserInfoStore(
        useShallow(state => ({
            isLogin: state.isLogin,
            userId: state.userInfo?.user_id,
            loginSource: state.userInfo?.login_source,
        }))
    );

// 用户设置选择器
export const useUserSettings = () =>
    useUserInfoStore(
        useShallow(state => ({
            theme: state.preferences?.theme,
            notifications: state.preferences?.notifications,
        }))
    );
